import { useParams } from "react-router-dom";
import QuotationForm from "./QuotationForm";
import BackButton from "../../../../components/Button/BackButton";

const EditQuotationPage = () => {
  const { id } = useParams();

  return (
    <div>
      <div className="flex items-center gap-3 mb-5">
        <BackButton />
        <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">Edit Quotation</h1>
      </div>

      <QuotationForm quotationId={id} />
    </div>
  );
};

export default EditQuotationPage;
